<template>
	<v-container class="loading-background" fluid fill-height>
		<v-layout row wrap align-center justify-center>
			<transition
				name="fade"
				appear
				appear-class="fade-enter"
				appear-to-class="fade-active"
				appear-active-class="fade-enter-active"
			>
				<h2 v-if="show">wrkprty</h2>
			</transition>
		</v-layout>
	</v-container>
</template>

<script>
import axios from 'axios'
import { mapActions, mapGetters } from 'vuex'
import { isEmpty } from '~/store/util/util'
import rawAxiosGet from '~/plugins/rawAxios'
import { segmentIdentify, segmentTrack } from '~/plugins/segment'
import { unsetToken } from '../../../utils/auth'

export default {
	data() {
		return {
			show: true
		}
	},
	created() {
		var oauthToken
		var verifier
		var authCode
		let cancel = false
		let params = window.location.search.slice(1).split(/[\?\&]+/)
		for (let param in params) {
			let prop = params[param].split('=')[0]
			let value = params[param].split('=')[1]
			if (prop === 'oauth_token') {
				oauthToken = value
			}
			if (prop === 'code') {
				authCode = value
			}
			if (prop === 'oauth_verifier') {
				verifier = value
			}
			if (prop === 'oauth_problem') {
				cancel = true
				console.error(value)
			}
		}
		let provider = window.localStorage.getItem('socialLoginProvider')
		window.history.replaceState({}, document.title, window.location.pathname)
		if (cancel) {
			this.$router.replace('/')
		}
		if (provider === 'facebook') {
			axios({
				method: 'post',
				url: process.env.VUE_APP_SERVER_PROTOCOL + process.env.VUE_APP_SERVER_URL + 'rest-auth/facebook/',
				data: JSON.stringify({
					'code': authCode
				}),
				headers: {
					'Content-Type': 'application/json'
				},
				withCredentials: false,
				transformRequest: (data, headers) => {
					delete headers['Authorization']
					delete headers.common['Authorization']
					return data
				}
			}).then((response) => {
				console.log('facebook login response')
				console.log(response)
				this.show = false
				this.setToken(response.data.token)
				this.setUserSocial(response.data.user)

				// Identify user in segment.com analytics tracking
				segmentIdentify(response.data.user)
				setTimeout(() => {
					console.log('sociallogin timeout')
					window.localStorage.removeItem('login_hash')
					if (response.data.user.active === false) {
						window.location.replace('/user/confirmation/')
					} else {
						if (this.getAuthRedirect) {
							let r = this.getAuthRedirect
							this.setAuthRedirect(null)
							window.location.replace(r)
						} else {
							window.location.replace('/')
						}
					}
				}, 1000)
			}).catch((error) => {
				console.error(error)
				window.localStorage.clear()
				unsetToken()
				if (typeof error == 'object' && error.hasOwnProperty('response')) {
					let data = error.response.data
					let errorMessages = [
						data.hasOwnProperty('non_field_errors') ? data.non_field_errors[0] : '',
						'Status Code: ' + error.response.status,
						'Raw Error Data: ' + JSON.stringify(error.response.data)
					]
					this.setGenericModalText(errorMessages)
				} else {
					this.setGenericModalText(['Unknown error has occurred', error])
				}
				this.setModalOpen({ prop: 'genericModal', value: true })
				this.$router.replace('/')
			})
		} else if (provider === 'linkedin') {
			// LINKEDIN
			// Set modal state and text to reflect login
			this.loginProcessing = true
			// this.loginRedirectText = 'Logging in with LinkedIn'

			axios({
				method: 'post',
				url: process.env.VUE_APP_SERVER_PROTOCOL + process.env.VUE_APP_SERVER_URL + 'rest-auth/linkedin/',
				data: JSON.stringify({
					'code': authCode
				}),
				headers: {
					'Content-Type': 'application/json'
				},
				withCredentials: false,
				transformRequest: (data, headers) => {
					delete headers['Authorization']
					delete headers.common['Authorization']
					return data
				}
			}).then((response) => {
						console.log(response)
						this.show = false
						this.setToken(response.data.token)
						this.setUserSocial(response.data.user)

						// Identify user in segment.com analytics tracking
						try {
							segmentIdentify(response.data.user)
						} catch (err) {
							console.error('Segment error')
						}
						setTimeout(() => {
							console.log('sociallogin timeout')
							if (response.data.user.active === false) {
								window.location.replace('/user/confirmation/')
							} else {
								if (this.getAuthRedirect) {
									let r = this.getAuthRedirect
									this.setAuthRedirect(null)
									window.location.replace(r)
								} else {
									window.location.replace('/')
								}
							}
							if (response.data.user.active === false) {
								window.localStorage.removeItem('login_hash')
							}
							if (this.getAuthRedirect) {
								let r = this.getAuthRedirect
								this.setAuthRedirect(null)
								window.location.replace(r)
							} else {
								window.location.replace('/')
							}
						}, 1000)
					}).catch((error) => {
						console.error('linkedin error')
						console.error(error)
						window.localStorage.clear()
						unsetToken()
						if (typeof error == 'object' && error.hasOwnProperty('response')) {
							let data = error.response.data
							let errorMessages = [
								data.hasOwnProperty('non_field_errors') ? data.non_field_errors[0] : '',
								'Status Code: ' + error.response.status,
								'Raw Error Data: ' + JSON.stringify(error.response.data)
							]
							this.setGenericModalText(errorMessages)
						} else {
							this.setGenericModalText(['Unknown error has occurred', error])
						}
						this.setModalOpen({ prop: 'genericModal', value: true })
						this.$router.replace('/')
					})
		}
	},
	methods: {
		...mapActions([
			'setFirstLogin',
			'setUserProp',
			'setAuthModalOpen',
			'setGenericModalText',
			'setModalOpen',
			'setAuthRedirect',
			'signUserInLinkedin',
			'setUserSocial',
			'setToken',
			'setSnackbarOpen',
			'setSnackbarText'
		])
	},
	computed: {
		...mapGetters(['getAuthRedirect'])
	}
}
</script>

<style>
.loading-background {
	background-color: #ebebeb;
}
.login-container {
	position: absolute;
	top: 0px;
	left: 0px;
	width: 100%;
	height: 100%;
}
.card-background-image > div:nth-child(1) {
	opacity: 0.4;
}
.fade-enter-active,
.fade-leave-active {
	transition: opacity 1s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
	opacity: 0;
}
.fade-active {
	opacity: 1;
}
</style>
